import { useParams } from 'react-router-dom'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { Features } from 'generated/featureDefinitions'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { getDefaultPeriodType } from 'modules/attendance/components/TimeTracking/Layout/form'

import { useAttendanceFeatures } from './attendanceFeaturesContext'

export interface TimeTrackingViewType {
  periodType: string
  year: number | string
  month: number | string
  day: number
}

export default function useCustomPeriodPath() {
  const { featureAvailability: showRealTimeAttendance } = useAttendanceFeatures(
    Features.time_tracking_real_time_attendance
  )
  const { navigation } = useNavigation()
  const params = useParams() // NOTE: Do not use useStrictParams here, as it will throw an error if the params are not present

  const [viewType, _] = useLocalStorage<TimeTrackingViewType>(
    LOCAL_STORAGE_KEYS.timeTrackingViewType
  )

  const today = new Date()
  let year = params.year ?? today.getFullYear()
  let month = params.month ?? today.getMonth() + 1
  let day = today.getDate()
  let periodType = params.periodType ?? getDefaultPeriodType({ showRealTimeAttendance })

  if (!!viewType) {
    periodType = viewType.periodType
    year = viewType.year
    month = viewType.month
    day = viewType.day
  }

  return navigation.timeTracking.list.periodTypeYearMonthDay.fullPath({
    periodType,
    year,
    month,
    day,
  })
}
